var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-card",class:[_vm.type, `type-${_vm.graphType}`],style:({
		'--reachedBackgroundColor': _vm.reachedBackgroundColor,
		'--reachedColor': _vm.reachedColor,
		'--reachedHoverBackgroundColor': _vm.reachedHoverBackgroundColor,
		'--notReachedBackgroundColor': _vm.notReachedBackgroundColor,
		'--notReachedColor': _vm.notReachedColor,
		'--aboveBackgroundColor': _vm.aboveBackgroundColor,
		'--aboveColor': _vm.aboveColor,
		'--noGoalBackgroundColor': _vm.noGoalBackgroundColor,
		'--noGoalColor': _vm.noGoalColor,
	})},[_c('div',{staticClass:"graph-header"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"graph-main"},[(_vm.graphType === 'progress')?[_c('div',{staticClass:"graph-body"},[_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"indicator-container",class:{
							noGoal: _vm.goal === null,
						}},[_c('div',{staticClass:"indicator-wrapper",on:{"click":function($event){return _vm.ChangeGoalQuestion(_vm.type)}}},[_c('span',{staticClass:"goal-value"},[_vm._v(_vm._s(_vm.goal))]),_c('i',{staticClass:"fas fa-caret-down"})])]),_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",class:{
								above: _vm.percentageValue > _vm.percentageGoal,
								reached: _vm.percentageValue === _vm.percentageGoal,
								reverse: _vm.reverse,
								noGoal: _vm.goal === null,
							},style:({ width: _vm.percentageValue + '%' })}),_c('h2',{staticClass:"statistic-value",class:{
								above: _vm.percentageValue > _vm.percentageGoal,
								reached: _vm.percentageValue === _vm.percentageGoal,
								reverse: _vm.reverse,
								noGoal: _vm.goal === null,
							}},[_vm._v(" "+_vm._s(_vm.value)+" ")])])])])]:(_vm.graphType === 'circular')?[_c('div',{staticClass:"graph-body"},[_c('div',{staticClass:"circular-donut",class:{
						above: _vm.percentageValue > _vm.percentageGoal,
						reached: _vm.percentageValue === _vm.percentageGoal,
						reverse: _vm.reverse,
						noGoal: _vm.goal === null,
					},style:({
						'--progress': _vm.animatedProgress,
						'--fontSize': _vm.donutFontSize + 'rem',
					})},[_c('div',{staticClass:"indicator-container",class:{
							noGoal: _vm.goal === null,
						}},[_c('div',{staticClass:"indicator-wrapper",on:{"click":function($event){return _vm.ChangeGoalQuestion(_vm.type)}}},[_c('span',{staticClass:"goal-value"},[_vm._v(_vm._s(_vm.goal))]),_c('i',{staticClass:"fas fa-caret-right"})])]),_c('div',{staticClass:"statistic-value-container"},[_c('h2',{staticClass:"statistic-value",class:{
								above: _vm.percentageValue > _vm.percentageGoal,
								reached: _vm.percentageValue === _vm.percentageGoal,
								reverse: _vm.reverse,
								noGoal: _vm.goal === null,
							}},[_vm._v(" "+_vm._s(_vm.value)),(_vm.type === 'no_show')?_c('span',[_vm._v("%")]):_vm._e()])])])])]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }